import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Manager } from '../../types/User';

export type ManagerState = {
  managers: Manager[];
};

const initialState: ManagerState = {
  managers: [],
};

const slice = createSlice({
  name: 'managers',
  initialState: initialState,
  reducers: {
    setManagers: (state, action: PayloadAction<any[]>) => {
      state.managers = action.payload;
    },
  },
});

export const { setManagers } = slice.actions;

export default slice.reducer;
